export enum EnticerSignalType {
  RESPONSIVE_EMPLOYER = "responsiveEmployer",
  HIRED_SIGNAL = "hiredSignal",
  TOP_RATED_EMPLOYER = "topRatedEmployer",
  EARLY_APPLICANT = "earlyApplicant",
}

export interface EnticerSignal {
  type: EnticerSignalType;
  text: string;
}

export interface FeaturedCardData {
  eligible: boolean;
  headerImageUrl: string | null;
  enticerSignals: EnticerSignal[];
}
